import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Shared";

export const CTABanner = ({
  heading = "Ready to build a stronger team?",
  highlight = "Let's talk.",
  text = "Tell us what you're hiring for. Our recruitment specialists respond within one business day.",
  primary = { label: "Start a Conversation", to: "/contact" },
  secondary = { label: "Explore Opportunities", to: "/job-seekers" },
}) => (
  <section className="bg-[#C62828] py-20 md:py-28" data-testid="cta-banner">
    <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
      <Reveal>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] tracking-tight">
          {heading} <span className="text-[#111111]">{highlight}</span>
        </h2>
      </Reveal>
      <Reveal i={1}>
        <p className="font-body text-white/85 text-lg mt-6 max-w-2xl mx-auto">{text}</p>
      </Reveal>
      <Reveal i={2}>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <Link to={primary.to} data-testid="cta-primary" className="group inline-flex items-center justify-center gap-2 bg-[#111111] text-white font-accent uppercase tracking-widest text-sm px-8 py-4 rounded-sm hover:bg-white hover:text-[#111111] transition-colors duration-400">
            {primary.label} <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
          {secondary && (
            <Link to={secondary.to} data-testid="cta-secondary" className="inline-flex items-center justify-center gap-2 border border-white/50 text-white font-accent uppercase tracking-widest text-sm px-8 py-4 rounded-sm hover:bg-white/10 transition-colors duration-400">
              {secondary.label}
            </Link>
          )}
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTABanner;
